import { t } from '../i18n';

const RATING_VALUES = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

interface Props {
  id: string;
  label: string;
  /** '' means no rating chosen yet. */
  value: string;
  onChange: (value: string) => void;
}

/** A shared 1-5, half-point-step rating selector (FR-013). */
export function RatingInput({ id, label, value, onChange }: Props) {
  return (
    <>
      <label htmlFor={id}>{label}</label>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{t('tasting.noRating')}</option>
        {RATING_VALUES.map((r) => (
          <option key={r} value={r}>
            {r}
          </option>
        ))}
      </select>
    </>
  );
}
